import { render, staticRenderFns } from "./ThemeSettingsDirectBottom.vue?vue&type=template&id=5cb0141b&scoped=true"
import script from "./ThemeSettingsDirectBottom.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0141b",
  null
  
)

export default component.exports